import React from "react";
import { observer } from "mobx-react-lite";
import { Button } from "@heroui/react";
import { contractorsStore } from "@/stores/ContractorsStore";

const formatMoney = (value: number) =>
  value.toLocaleString("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  });

interface PayoutBlockProps {
  onPayout: () => void;
}

const PayoutBlock: React.FC<PayoutBlockProps> = observer(({ onPayout }) => {
  const { totalDebt, payableCount } = contractorsStore;

  return (
    <div className="sc-payout-block" data-testid="contractors-payout-block">
      <div className="sc-payout-block__info">
        <span className="sc-payout-block__label">К выплате</span>
        <span className="sc-payout-block__amount">
          {formatMoney(totalDebt)}
        </span>
        <span className="sc-payout-block__hint">
          {payableCount > 0
            ? `${payableCount} ${payableCount === 1 ? "контрагенту" : "контрагентам"}`
            : "Нет задолженности по выбранным"}
        </span>
      </div>
      <div className="sc-payout-block__actions">
        <Button
          variant="primary"
          isDisabled={totalDebt === 0}
          className="sc-payout-block__btn"
          data-testid="contractors-payout-button"
          onPress={onPayout}
        >
          Выплатить
        </Button>
        <Button
          variant="tertiary"
          onPress={() => contractorsStore.clearSelection()}
          className="sc-payout-block__cancel"
          data-testid="contractors-payout-clear-selection-button"
        >
          Отменить выбор
        </Button>
      </div>
    </div>
  );
});

PayoutBlock.displayName = "PayoutBlock";
export default PayoutBlock;
